import React, { Component } from 'react';
import PropTypes from 'prop-types';

import TasksListForEdit from './TasksListForEdit';
import TaskForm from './TaskForm';

class ManageTasksDialog extends Component {
	render () {
		const { list, name, loadTasksFinished, onRemove } = this.props;

		return (
			<div>
				<h3 className="text-center">Задачи для сотрудника: {name}</h3>
				{
					list.length ?
						<TasksListForEdit onRemove={onRemove} list={list} loadTasksFinished={loadTasksFinished} /> :
						'У пользователя еще нет задач'
				}
				<TaskForm onSubmit={this.props.onAdd} userId={+this.props.userId} />
			</div>
		);
	}
}

ManageTasksDialog.propTypes = {
	list: PropTypes.array,
	name: PropTypes.string,
	loadTasksFinished: PropTypes.func,
	onAdd: PropTypes.func,
	onRemove: PropTypes.func,
	userId: PropTypes.string
};

export default ManageTasksDialog;


// WEBPACK FOOTER //
// ./components/ManageTasksDialog.js